"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    PERSONALIZED_GREETING_URL: ()=>PERSONALIZED_GREETING_URL,
    SPEECH_URL: ()=>SPEECH_URL,
    SPEECH_TIMEOUT: ()=>SPEECH_TIMEOUT,
    IS_STORYBOOK: ()=>IS_STORYBOOK,
    IS_CHROMATIC: ()=>IS_CHROMATIC,
    IS_DEBUG: ()=>IS_DEBUG,
    IS_DEV: ()=>IS_DEV,
    TRANSCRIPTION_URL: ()=>TRANSCRIPTION_URL,
    TRANSCRIPTION_TIMEOUT: ()=>TRANSCRIPTION_TIMEOUT,
    RETRIEVE_URL: ()=>RETRIEVE_URL,
    getServiceConfig: ()=>getServiceConfig
});
const getHostingApp_js_namespaceObject = require("../utils/getHostingApp.js");
const getRequestHeaders_js_namespaceObject = require("../utils/getRequestHeaders.js");
const urls_js_namespaceObject = require("../constants/urls.js");
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const IS_DEV = 'undefined' != typeof process && 'development' === process.env.NODE_ENV;
const IS_STORYBOOK = 'undefined' != typeof process && !!process.env.STORYBOOK_ENV;
const IS_CHROMATIC = 'undefined' != typeof window && !!location?.href?.match(/chromatic/);
const host = (0, getHostingApp_js_namespaceObject.getHostName)(IS_STORYBOOK, IS_CHROMATIC);
const IS_DEBUG = false;
const PERSONALIZED_GREETING_URL = `${host}/genai-svc/genai/personalization/get-personalized-greeting`;
const RETRIEVE_URL = `${host}/genai-svc/genai/chat/retrieve-prompts`;
const SPEECH_URL = `${host}/genai-svc/genai/speech`;
const SPEECH_TIMEOUT = 10000;
const TRANSCRIPTION_URL = `${host}/genai-svc/genai/audio/transcriptions`;
const TRANSCRIPTION_TIMEOUT = 10000;
const getServiceConfig = (viewType, isMobile, customerName = '', logAnalytics)=>{
    const sameForAll = {
        personalizedGreetingUrl: PERSONALIZED_GREETING_URL,
        retrieveUrl: RETRIEVE_URL,
        speechFetchRequestOptions: {
            url: SPEECH_URL,
            timeout: SPEECH_TIMEOUT
        },
        transcriptionFetchRequestOptions: {
            url: TRANSCRIPTION_URL,
            timeout: TRANSCRIPTION_TIMEOUT
        }
    };
    const serviceConfig = {
        LANDING: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${urls_js_namespaceObject.IMPLEMENTATION_ENDPOINTS.LANDING}`,
                headers: (0, getRequestHeaders_js_namespaceObject.getRequestHeaders)(isMobile, {
                    'x-request-from': 'homePage'
                })
            },
            ga4ProductName: '',
            isDev: IS_DEV,
            requestFrom: 'homePage',
            returnJSONResponse: true,
            showLandingChat: true,
            viewType,
            ...sameForAll
        },
        CHECKOUT: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${urls_js_namespaceObject.IMPLEMENTATION_ENDPOINTS.CHECKOUT}`,
                headers: (0, getRequestHeaders_js_namespaceObject.getRequestHeaders)(isMobile, {
                    'x-request-from': 'UC'
                })
            },
            ga4ProductName: '',
            isDev: IS_DEV,
            requestFrom: 'UC',
            returnJSONResponse: true,
            showLandingChat: false,
            viewType,
            ...sameForAll
        },
        DRIVE: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${urls_js_namespaceObject.IMPLEMENTATION_ENDPOINTS.DRIVE}`,
                headers: (0, getRequestHeaders_js_namespaceObject.getRequestHeaders)(isMobile, {
                    'x-request-from': 'rcListingPage'
                })
            },
            ga4ProductName: 'car',
            isDev: IS_DEV,
            requestFrom: 'rcListingsPage',
            returnJSONResponse: true,
            showLandingChat: false,
            viewType,
            ...sameForAll
        },
        FLYDETAILS: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${urls_js_namespaceObject.IMPLEMENTATION_ENDPOINTS.FLYDETAILS}`,
                headers: (0, getRequestHeaders_js_namespaceObject.getRequestHeaders)(isMobile, {
                    'x-request-from': 'productDetailPage'
                })
            },
            ga4ProductName: 'air',
            isDev: IS_DEV,
            requestFrom: 'productDetailPage',
            returnJSONResponse: true,
            showLandingChat: false,
            viewType,
            ...sameForAll
        },
        FLYLISTINGS: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${urls_js_namespaceObject.IMPLEMENTATION_ENDPOINTS.FLYDETAILS}`,
                headers: (0, getRequestHeaders_js_namespaceObject.getRequestHeaders)(isMobile, {
                    'x-request-from': 'productListingPage'
                })
            },
            ga4ProductName: 'air',
            isDev: IS_DEV,
            requestFrom: 'productListingPage',
            returnJSONResponse: true,
            showLandingChat: false,
            viewType,
            ...sameForAll
        },
        ITINERARY: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${urls_js_namespaceObject.IMPLEMENTATION_ENDPOINTS.ITINERARY}`,
                headers: (0, getRequestHeaders_js_namespaceObject.getRequestHeaders)(isMobile, {
                    'x-request-from': 'travel-itinerary'
                })
            },
            ga4ProductName: '',
            isDev: IS_DEV,
            requestFrom: 'travel-itinerary',
            showLandingChat: false,
            viewType,
            ...sameForAll
        },
        PORTAL: {
            customerName,
            debugMode: IS_DEV,
            ga4ProductName: '',
            isDev: IS_DEV,
            viewType,
            showLandingChat: false,
            returnJSONResponse: true,
            requestFrom: 'pennyPortalPage',
            fetchRequestOptions: {
                url: `${host}${urls_js_namespaceObject.IMPLEMENTATION_ENDPOINTS.PORTAL}`,
                headers: {
                    'x-request-from': 'pennyPortalPage',
                    'x-model-version': '4'
                }
            },
            ...sameForAll
        },
        STAYDETAILS: {
            customerName,
            debugMode: IS_DEV,
            ga4ProductName: 'hotel',
            isDev: IS_DEV,
            viewType,
            showLandingChat: false,
            requestFrom: 'hotelDetailPage',
            returnJSONResponse: true,
            fetchRequestOptions: {
                url: `${host}${urls_js_namespaceObject.IMPLEMENTATION_ENDPOINTS.STAYDETAILS}`,
                headers: (0, getRequestHeaders_js_namespaceObject.getRequestHeaders)(isMobile, {
                    'x-request-from': 'hotelDetailPage'
                })
            },
            ...sameForAll
        },
        STAYLISTINGS: {
            customerName,
            debugMode: IS_DEV,
            ga4ProductName: 'hotel',
            isDev: IS_DEV,
            viewType,
            showLandingChat: false,
            requestFrom: 'hotelListingPage',
            returnJSONResponse: true,
            fetchRequestOptions: {
                url: `${host}${urls_js_namespaceObject.IMPLEMENTATION_ENDPOINTS.STAYLISTINGS}`,
                headers: (0, getRequestHeaders_js_namespaceObject.getRequestHeaders)(isMobile, {
                    'x-request-from': 'hotelListingPage'
                })
            },
            ...sameForAll
        }
    };
    const config = serviceConfig[viewType];
    if (!config) throw new Error(`No service configuration found for viewType: ${viewType}. Add configuration to serviceConfig object in /react-components/penny-chat-bot/src/config/serviceConfig.ts. `);
    const resolvedConfig = {
        ...config,
        logAnalytics: {
            logCustomerCarePhoneNumberClicked: ()=>{},
            logCustomerCarePhoneNumberDisplayed: ()=>{},
            logChatInitialization: ()=>{
                analytics_js_default().fireGA4Event({
                    event: 'initiate_chat',
                    attributes: {
                        type: 'penny',
                        page_name: config.requestFrom,
                        product_name: config.ga4ProductName
                    }
                });
            },
            logFirstMessageSubmitted: (chatMessages)=>{
                if (chatMessages.filter((m)=>'user' === m.role && '' !== m.content).length <= 1) analytics_js_default().fireGA4Event({
                    event: 'begin_chat',
                    attributes: {
                        type: 'penny',
                        page_name: config.requestFrom,
                        product_name: config.ga4ProductName
                    }
                });
            },
            ...logAnalytics
        }
    };
    return resolvedConfig;
};
exports.IS_CHROMATIC = __webpack_exports__.IS_CHROMATIC;
exports.IS_DEBUG = __webpack_exports__.IS_DEBUG;
exports.IS_DEV = __webpack_exports__.IS_DEV;
exports.IS_STORYBOOK = __webpack_exports__.IS_STORYBOOK;
exports.PERSONALIZED_GREETING_URL = __webpack_exports__.PERSONALIZED_GREETING_URL;
exports.RETRIEVE_URL = __webpack_exports__.RETRIEVE_URL;
exports.SPEECH_TIMEOUT = __webpack_exports__.SPEECH_TIMEOUT;
exports.SPEECH_URL = __webpack_exports__.SPEECH_URL;
exports.TRANSCRIPTION_TIMEOUT = __webpack_exports__.TRANSCRIPTION_TIMEOUT;
exports.TRANSCRIPTION_URL = __webpack_exports__.TRANSCRIPTION_URL;
exports.getServiceConfig = __webpack_exports__.getServiceConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "IS_CHROMATIC",
    "IS_DEBUG",
    "IS_DEV",
    "IS_STORYBOOK",
    "PERSONALIZED_GREETING_URL",
    "RETRIEVE_URL",
    "SPEECH_TIMEOUT",
    "SPEECH_URL",
    "TRANSCRIPTION_TIMEOUT",
    "TRANSCRIPTION_URL",
    "getServiceConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
